import React from 'react';

import { Link } from 'react-router-dom'
import Links from "./links";

import '../styles/footer.css'

class Footer extends React.PureComponent {
    render() {
        return (
            <footer className="footer active">
                <div className="container_content">
                    <div className="footer_container">
                        <div className="footer_container_item footer_contact">
                            <Link to="/contact" className="footer_contact_link">
                                <div className="footer_contact_link_text">
                                    Contact Us
                                </div>
                            </Link>
                        </div>
                        <div className="footer_container_item footer_navigation">
                            <p className="footer_navigation_title">Menu</p>
                            <Links></Links>
                        </div>
                        <div className="footer_container_item footer_info">
                            <p className="footer_info_title">Info</p>
                            <div className="footer_info_content">
                                <address>
                                    SF No:-348-1A3, Sri Lakshmi Nagar II<br />
                                    Thanneer Pandhal Road, Peelamedu, <br />
                                    Coimbatore 641004 <br />
                                    Tamil Nadu, India <br />
                                    <a href="tel:+918807044987">+91 88070 44987</a>
                                </address>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer_socials">
                    <ul>
                        <li className="footer_socials_list"><a href="https://www.instagram.com/dotworldindia/">Instagram</a></li>
                        <li className="footer_socials_list"><a href="https://www.facebook.com/DotworldTechIndia">Facebook</a></li>
                        <li className="footer_socials_list"><a href="https://twitter.com/DotworldIndia">Twitter</a></li>
                        <li className="footer_socials_list"><a href="http://linkedin.com/company/dotworldindia">LinkedIn</a></li>
                        <li className="footer_socials_list"><a href="mailto:hello@dotworld.in">Email</a></li>
                    </ul>

                </div>
               {/*  <div class="footer_socials_right">
                    <span>
                        &copy; {new Date().getFullYear()} Dotworld Technologies
                    </span>
                </div> */}
                <div className="footer_wrapper"></div>

            </footer>
        );
    }
}

export default Footer;